<template>
    <div class="coupon" v-if="!!params.items && params.items.length>0">
        <div class="coupon-title">
            <div class="title-txt">
                {{params.title}}
            </div>
            <div class="title-more" @click="onClick(params.link_info.link)" v-if="params.link_info.link">
                {{!!params.link_info.name?params.link_info.name:'更多'}}
            </div>
        </div>
        <div class="coupon-list">
            <div class="coupon-li" v-for="(item,index) in params.items" :key="index" @click="onClick(item.link)">
                <div class="coupon-li-content">
                    <div class="coupon-type">
                        <span class="coupon-txt" v-if="item.coupon_type == 1">抵扣券</span>
                        <span class="coupon-txt" v-if="item.coupon_type == 2">折扣券</span>
                    </div>
                    <div class="coupon-money">
                        <span v-if="item.coupon_type == 1">{{item.money * 1}}</span>
                        <span v-if="item.coupon_type == 2">{{item.discount * 1}}折</span>
                    </div>
                    <div class="coupon-content">
                        <span v-if="item.full_money*1 >0">满{{item.full_money * 1}}元可用</span>
                        <span v-else>无门槛使用</span>
                    </div>
                </div>
                <div class="coupon-btn">
                    领<br>取
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "coupon",
        props:{
            params:Object
        },
        methods:{
            onClick(e){
                this.$router.push(e)
            },
        }
    }
</script>

<style scoped>
    .coupon-type{
        height: 20px;
    }
    .coupon-type .coupon-txt{
        position: absolute;
        top: 0;
        left: 0;
        font-size: 12px;
        padding: 0 5px;
        background-color: #ff847c;
        border-radius: 5px 0 5px 0;
    }
    .coupon{
        background-color: #fff;
        margin: 10px 0;
    }
    .coupon-list{
        width: 100%;
        overflow-x: scroll ;
        white-space: nowrap;
        box-sizing: border-box;
    }
    .coupon-title{
        /*padding: 10px;*/
        background-color: #fff;
    }
    .coupon-title .title-txt,.coupon-title .title-more{
        display: inline-block;
        vertical-align: middle;
    }
    .coupon-title .title-txt{
        max-width: 80%;
        font-size: 16px;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #171717;
    }
    .coupon-title .title-more{
        float: right;
        color: #327CE9;
        font-size: 12px;
        margin-top: 2px;
    }
    .coupon-li{
        display: inline-block;
        height: 100px;
        background-color: #e84a5f;
        color: #fff;
        vertical-align: middle;
        margin-right: 6px;
        border-radius: 5px;
        overflow: hidden;
        margin: 10px;
        margin-left: 0;
        /*box-shadow: 1px 1px 8px #ccc;*/
    }
    .coupon-li .coupon-li-content{
        text-align: center;
        display: inline-block;
        min-width: 115px;
        height: 100px;
        position: relative;
        line-height: 25px;
        padding: 5px;
        box-sizing: border-box;
    }
    .coupon-li .coupon-btn{
        width: 30px;
        display: inline-block;
        text-align: center;
        border-right: 3px dashed #fff;
        border-left: 1px dashed #fff;
        height: 80px;
        vertical-align: top;
        margin-top: 10px;
        line-height: 40px;
        position: relative;
    }
    .coupon-li .coupon-li-content::after,.coupon-li .coupon-li-content::before{
        content: '';
        position: absolute;
        width: 10px;
        height: 10px;
        background-color: #fff;
        border-radius: 5px;
        right: -5px;
    }
    .coupon-li .coupon-li-content::after{
        bottom: -5px;
    }
    .coupon-li .coupon-li-content::before{
        top: -5px;
    }
    .coupon-list::-webkit-scrollbar {
        display: none; /* Chrome Safari */
    }
    .coupon-li-content .coupon-money{
        font-size: 23px;
        font-weight: bold;
    }
</style>
